import styled from "styled-components";

import Background from '../../../../../assets/images/banners/banner_site3.webp';

export const BaseDiv = styled.div`
    margin: 2% 0%;
    padding: 6% 0;
    max-width: '100%';
    justify-content: center;
    display: flex;
    max-width: 100%;


    @media only screen and (max-width: 1000px) {
        background-image: url(${Background});
    }

    .SwiperName {
        @media only screen and (max-width: 800px) {
            max-width: 50%;
            width: 50%;
        }
    }

    .swiper-wrapper .wiper-slide {
        @media only screen and (max-width: 800px) {
            width: 200px;
        }
    }
`;

export const PrincipalDiv = styled.div`
    width: 100%;
    padding: 8%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;
    @media only screen and (max-width: 1400px) {
        padding: 5%;
    }

`;

export const CardBody = styled.div`
    background-color: white;
    display: flex;
    justify-content: space-evenly;
    flex-direction: row;
    height: 600px;
    color: var(--purple-lightdark);
    @media only screen and (max-width: 1400px) {
        height: 680px;
    }
    @media only screen and (max-width: 1000px) {
        flex-direction: column;
        height: auto;
    }
`;

export const CardLogo = styled.div`
    height: 85px;
    padding-top: 2px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media only screen and (max-width: 800px) {
        height: 60px;
        padding-top: 2px;
    }
    img {
        max-width: 100;
        max-height: 20;
    }
`;

export const CardContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;

    margin: 1%;
    width: 45%;
    padding: 20px;

    background: #fff;
    border-radius: 16px;
    border: 1px solid #e2e2e2;
    box-shadow: 0 4px 10px rgba(0,0,0,0.08);
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-4px);

        box-shadow: 0 8px 20px rgba(0,0,0,0.15);
    }

    p {
        font-size: 1rem;
        padding: 5px 10px;
        color: black;
    }
    @media only screen and (max-width: 1000px) {
        width: 50%;
    }
    @media only screen and (max-width: 1000px) {
        width: 100%;
        margin-bottom: 5%;
        border-radius: 16px;
    }
`;

export const CardName = styled.div`
    font-size: 14px;
    color: black;
`;

